export default __webpack_public_path__ + "resources/icons/d422-2623.png";